module.exports = __webpack_public_path__ + "static/media/grapes.71b90880.jpg";